/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiReservedLocationPageTaggerFromJSON, ApiReservedLocationPageTaggerToJSON, } from './ApiReservedLocationPageTagger';
export function ApiLocationPageTaggerSimplifiedFromJSON(json) {
    return ApiLocationPageTaggerSimplifiedFromJSONTyped(json, false);
}
export function ApiLocationPageTaggerSimplifiedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'crawlSearchParams': !exists(json, 'crawlSearchParams') ? undefined : json['crawlSearchParams'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'regex': !exists(json, 'regex') ? undefined : json['regex'],
        'reserved': !exists(json, 'reserved') ? undefined : ApiReservedLocationPageTaggerFromJSON(json['reserved']),
        'selector': !exists(json, 'selector') ? undefined : json['selector'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiLocationPageTaggerSimplifiedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'crawlSearchParams': value.crawlSearchParams,
        'id': value.id,
        'locationId': value.locationId,
        'name': value.name,
        'projectId': value.projectId,
        'regex': value.regex,
        'reserved': ApiReservedLocationPageTaggerToJSON(value.reserved),
        'selector': value.selector,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
